import { CustomerFilter, CustomFilter } from '@/customer/models/CustomerFilter';
import { PropType } from '@/customer/models/CustomerProp';

function validCustoms(filter: CustomerFilter): CustomFilter[] {
  return filter.custom.filter((custom: CustomFilter) => {
    if (custom.prop === undefined) {
      return false;
    } else {
      if ([PropType.LocalDate, PropType.DateTime].includes(custom.prop.propType)) {
        return custom.date;
      } else if (PropType.Numeric === custom.prop.propType) {
        return custom.num !== undefined;
      } else {
        return custom.keywords && custom.keywords.length;
      }
    }
  });
}

export default {
  isFilterSex(filter: CustomerFilter): boolean {
    return filter.sex !== -1;
  },
  isFilterSubscribe(filter: CustomerFilter): boolean {
    return filter.subscribe.periods &&
      filter.subscribe.periods.length > 0 &&
      filter.subscribe.periods[0] !== '';
  },
  isFilterArea(filter: CustomerFilter): boolean {
    return filter.area.areas &&
      filter.area.areas[0].length > 0;
  },
  isFilterSubscribeScene(filter: CustomerFilter): boolean {
    return filter.subscribeScene.scenes.length > 0;
  },
  isFilterInteract(filter: CustomerFilter): boolean {
    return filter.interact &&
      filter.interact.period !== -1;
  },
  isFilterTrace(filter: CustomerFilter): boolean {
    return filter.trace.compare < 0 || filter.trace.count > 0;
  },
  isFilterScore(filter: CustomerFilter): boolean {
    return filter.score !== undefined &&
      (filter.score.minScore !== null || filter.score.maxScore !== null);
  },
  isFilterScoreSum(filter: CustomerFilter): boolean {
    return filter.scoreSum !== undefined &&
      (filter.scoreSum.minScore !== null || filter.scoreSum.maxScore !== null);
  },
  isFilterMember(filter: CustomerFilter): boolean {
    return filter.member &&
      filter.member.memberIds.length > 0;
  },
  isFilterGroup(filter: CustomerFilter): boolean {
    return filter.group &&
      filter.group.groupIds.length > 0;
  },
  isFilterTopics(filter: CustomerFilter): boolean {
    return filter.topics &&
      filter.topics.length > 0;
  },
  isFilterRemark(filter: CustomerFilter): boolean {
    const remarks = filter.remark && filter.remark.remarks;
    const groups = filter.remark && filter.remark.remarkGroups;
    return (remarks && remarks.length > 0) || (groups && groups.length > 0);
  },
  isFilterCustom(filter: CustomerFilter): boolean {
    return validCustoms(filter).length > 0;
  },
  isFilterTopic(filter: CustomerFilter): boolean {
    return filter.topicQuery && filter.topicQuery.topics.length > 0;
  },
  validCustoms,
};
